import Icon from '~/components/scales/Icon/Icon';
import TextInput from '~/components/scales/TextInput/TextInput';

export default function SearchEntriesInput(props: {
  onChange: (value: string) => void;
  onEscape: () => void;
  value: string;
}) {
  return (
    <div className="bg-background-primary p-2">
      <TextInput
        aria-label="search entries"
        autoFocus
        onChange={props.onChange}
        onClear={() => props.onChange('')}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            props.onEscape();
          }
        }}
        placeholder="Search entries..."
        startAdornment={<Icon name="search" />}
        value={props.value}
      />
    </div>
  );
}
